export default __webpack_public_path__ + "static/decorist-4-a-fdf27f202cd5774c1bdfd50db5d48446.webp";